import Vue from 'vue'

export default store => {
    store.subscribe(function (mutation, state) {
        if (mutation.type === 'createNew') {
            /*
            Vue.Remote.emit('DetectScenes', {
                src: mutation.payload
            })
            */
            store.dispatch('notify', {title: 'new...', text: 'DetectScenes event sent', sticky: 2000})
        }
        if (mutation.type === 'addTag') {
            /*
            Vue.Remote.emit('TrackObject', {
                src: mutation.payload
            })
            */
            store.dispatch('notify', {title: 'tag added', text: 'TrackObject event sent', sticky: 2000})
        }
        if (mutation.type === 'setPlayer') {
            // attachSocketHandlers(store)
        }
        if (mutation.type === 'addScene') {
            store.dispatch('notify', {title: 'scene created', text: '', sticky: 1500})
        }

        if (mutation.type === 'createAsset') {
          store.dispatch('notify', {title: 'Created', text: 'Asset was created', sticky: 2000})
        }

        if (mutation.type === 'saveAsset') {
            store.dispatch('notify', {title: 'Saved', text: 'Changes were saved to asset', sticky: 2000})
        }
    })
}

function attachSocketHandlers(store) {
    Vue.Remote.attach('DetectScenes', function (data) {
      if (data.type.toLowerCase() === 'started' || data.type.toLowerCase() === 'done') {
        store.dispatch('notify', {title: 'Scene Detection ' + data.type, text: '', sticky: 1500})
      } else {
        store.dispatch('notify', {title: 'Scene Detection', text: `Detected: ${data.scenes.length} scenes and a framerate of ${data.framerate}`, sticky: 1500})
        store.commit('receiveVideoScenes', data)
      }
    })

    Vue.Remote.attach('TrackObject', function (data) {
        store.dispatch('notify', {title: 'Object tracked', text: `Waypoint added...`, sticky: 1500})
        store.dispatch('addTrackedWaypoints', data)
        store.commit('receiveTracking', data)
    })
}
